import React, { useEffect, useState } from 'react';
import { FullScreenLoader, NotificationSettingsUI } from 'src/app/components';
import { toast } from "react-toastify";
import { AxiosError } from 'axios';
import { APP_MESSAGES } from 'src/shared/config/src';
import { API_URL } from 'src/app/config/appConstants';
import { fetchNotificationSettingsDetails, updateNotificationSettings } from 'src/shared/services/src';
import { NotificationSettingsData } from 'src/shared/types/src';
import BackButtonLayout from 'src/app/layouts/BackButtonLayout';
import { AppRoutes } from 'src/app/navigation/routes';
import { useNavigate } from 'react-router-dom';

const UnsubscribeEmailScreen = () => {

  const navigate = useNavigate();

  const [settingsLoader, setSettingsLoader] = useState<boolean>(false);
  const [notificationSettingsData, setNotificationSettingsData] = useState<NotificationSettingsData>()
  const [isEmailEnabled, setIsEmailEnabled] = useState<boolean>(false); // [isEmailNotificationEnabled, setIsEmailNotificationEnabled]

  useEffect(() => {

    getNotificationSettings()
  }, [])

  const getNotificationSettings = async () => {
    try {
      setSettingsLoader(true)
      if (!API_URL) throw new Error('API_URL is not defined')
      const response = await fetchNotificationSettingsDetails();
      if (response && response?.user && response?.user?.notificationSettings && Object.keys(response?.user?.notificationSettings).length > 0) {
        const data: NotificationSettingsData = {
          emailNotfications: {
            types: response?.user?.notificationSettings
          },
          pushNotifications: response?.user?.notificationEnabled?.push || true,
        }
        setNotificationSettingsData(data)
        setIsEmailEnabled(response?.user?.notificationEnabled?.email || false)
      } else {
        toast.error(APP_MESSAGES.generalErrorMessage, { autoClose: 5000 });
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        const apiError = error as AxiosError;
        if (apiError && apiError.response) {
          const { errors } = error.response?.data;
          toast.error(errors.join(", "), { autoClose: 5000 });
        } else {
          toast.error(APP_MESSAGES.generalErrorMessage, { autoClose: 5000 });
        }
      }
    } finally {
      setSettingsLoader(false);
    }
  }

  const submitSettings = async (payload: NotificationSettingsData, successCallBack: () => void, callBack: () => void) => {

    try {
      const response = await updateNotificationSettings(payload);
      if (response) {
        toast.success('Notification Settings saved!', { autoClose: 5000 });
        successCallBack();
        navigate(AppRoutes.HOME)
      } else {
        toast.error(APP_MESSAGES.generalErrorMessage, { autoClose: 5000 });
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        const apiError = error as AxiosError;
        if (apiError && apiError.response) {
          const { errors } = error?.response?.data;
          toast.error(errors.join(", "), { autoClose: 5000 });
        } else {
          toast.error(APP_MESSAGES.generalErrorMessage, { autoClose: 5000 });
        }
      }
    } finally {
      callBack();
    }
  }

  return (
    <BackButtonLayout title="Notification Settings">
      {settingsLoader ?
        <FullScreenLoader /> :
        <>
          {notificationSettingsData ?
            <NotificationSettingsUI
              notificationSettingsData={notificationSettingsData}
              isEmailEnabled={isEmailEnabled}
              submitSettings={submitSettings}
            /> :
            null
          }
        </>
      }
    </BackButtonLayout>
  )
}

export default UnsubscribeEmailScreen;